'use client';

import type { ReactNode } from 'react';
import Link from 'next/link';
import Image from 'next/image';
import { LogIn } from 'lucide-react';

/**
 * Schlanke öffentliche Hülle für die Hilfe/FAQ (/informationen), wenn der Nutzer
 * NICHT voll eingeloggt ist (anonym oder ohne Portal-Zugang). Statt der AppShell-
 * Sidebar (die einen Login voraussetzt) nur ein sticky Header (Logo → Anmelden) +
 * Inhalt. Das Fenster scrollt — der sticky Header (h-14) passt zum Sticky-Offset
 * der mobilen Themen-Rail (top-14).
 */
export function PublicInfoShell({ children }: { children: ReactNode }) {
  return (
    <div className="min-h-[100dvh] bg-surface">
      <header className="sticky top-0 z-30 flex h-14 items-center gap-3 border-b border-zinc-200 bg-white px-4 dark:bg-white/5">
        <Link href="/login" className="flex shrink-0 items-center" aria-label="Zur Anmeldung">
          <Image
            src="/logo-dachbaustoffe_color.svg"
            alt="Paeffgen Dachbaustoffe"
            width={140}
            height={28}
            className="h-7 w-auto object-contain dark:hidden"
            priority
          />
          <Image
            src="/logo-dachbaustoffe_dark.svg"
            alt="Paeffgen Dachbaustoffe"
            width={140}
            height={28}
            className="hidden h-7 w-auto object-contain dark:block"
            priority
          />
        </Link>
        <div className="flex-1" />
        <Link
          href="/login"
          className="inline-flex h-9 items-center gap-2 rounded-lg bg-primary px-3.5 text-sm font-semibold text-white transition-colors hover:bg-primary-hover"
        >
          <LogIn className="h-4 w-4" /> Anmelden
        </Link>
      </header>
      <main className="container mx-auto max-w-7xl p-4 md:p-8">{children}</main>
    </div>
  );
}
